import { render, staticRenderFns } from "./ProductEdit.vue?vue&type=template&id=19a29a70&scoped=true&"
import script from "./ProductEdit.vue?vue&type=script&lang=js&"
export * from "./ProductEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProductEdit.vue?vue&type=style&index=0&id=19a29a70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a29a70",
  null
  
)

export default component.exports